import { createStore } from 'satcheljs';
export default createStore('blockedDomainsOption', {
    blockedDomains: null,
})();
//# sourceMappingURL=store.js.map